const featuresPriority = {
  'features-priority-form-date-label': 'Date',
  'features-priority-filter-title': 'Select features by date',
  'features-priority-title': 'Set specific order for featured content',
  'features-priority-update-no-order-changed': 'The order of priority has not been changed',
};

export default featuresPriority;
